
















import SkeletonLoader from "@/modules/externals/components/SkeletonLoader.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "skeleton-loader": SkeletonLoader,
  },
})
export default class TableLoader extends Vue {
  @Prop({ default: 5 }) numberOfColumns!: number;
}
